<template>
    <div>
        <v-text-field
            :label="label"
            hide-details="auto"
            v-model="currentValue"
            :readonly="true"
        >
        </v-text-field>
        <div class="mt-4">
            <v-btn class="mr-3" @click="generateApiKey" small>{{ labels.generateNewApiKey }}</v-btn>
            <v-btn @click="deleteApiKey" small>{{ labels.deleteApiKey }}</v-btn>
        </div>
    </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import translate from '@/utils/genTable/multilanguageHelper.js'

export default {
    data() {
        return {
            currentValue: this.value ? this.value : "",
            labels: {
                generateNewApiKey: translate("Generate new api key", "pages.tenantsettings"),
                deleteApiKey: translate("Delete api key", "pages.tenantsettings")
            }
        }
    },
    props: {
        label: String,
        value: String
    },
    methods: {
        generateApiKey() {
            this.currentValue = uuidv4()
        },
        deleteApiKey() {
            this.currentValue = "";
        }  
    },
    watch: {
        currentValue: {
            handler() {
                this.$emit('input', this.currentValue)
            }
        },
        value: {
            handler() {
                this.currentValue = this.value
            }
        }
    }
}
</script>